(ns minorodata.components.sql-console-modal.utils
  (:require [re-posh.core :as re-posh]
            [minorodata.app.handlers :refer [dispatch]]))


(defn tab-id [idx]
  (str "sql-console-modal-tab-" idx))

(defn close-tab [idx]
  (let [tab-count @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-count])]
    (if (> tab-count 1)
      (dispatch [:sql-console.events/delete-tab idx])
      (dispatch [:sql-console.events/reset-tab idx]))))

(defn close-tab-by-tab-id [tab-id]
  (let [tdc @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
        tab-idx (.indexOf (map (comp :tab-id :metadata) tdc)
                          tab-id)]

    (when (not= -1 tab-idx)
      (close-tab tab-idx))))
